<template>
  <section id="about-hero" class="py-20 text-center bg-gradient-to-b from-primary/10 to-base-100 relative">
    <div class="container mx-auto px-4">
      <h1 class="text-5xl font-bold mb-4 text-primary">
        {{ $t("aboutPage.hero.title") }}
      </h1>
      <p class="text-lg text-base-content/70 max-w-2xl mx-auto mb-6">
        {{ $t("aboutPage.hero.subtitle") }}
      </p>
      <a href="#contact-form" class="btn btn-primary btn-lg">
        {{ $t("aboutPage.hero.cta") }}
      </a>
    </div>
  </section>
</template>
